export default "__VITE_ASSET__B2RY8Ibb__"